var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid" }, [
    _c("div", { staticClass: "grid__col--12 mix__chart mix__chart--mfg" }, [
      _c("table", { staticClass: "pieTable" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.products, function(product, index) {
            return _c("Product", {
              key: index,
              attrs: { rank: index + _vm.indexOffset, product: product }
            })
          }),
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "pieTable__header" }, [
      _c(
        "th",
        {
          staticClass: "pieTable__header pieTable__header--key",
          attrs: { colspan: "3" }
        },
        [_vm._v("PRODUCT")]
      ),
      _vm._v(" "),
      _c("th", { staticClass: "pieTable__header pieTable__header--value" }, [
        _vm._v("Units Sold")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }